/**
 * 사내결재 처리 이력 표시 (v2.99.0) — 지출결재·휴일근무일지 문서 모달 공용. 회의록 동의 서명 이력도 (v2.229.0).
 *
 * ⭐문서의 반려 사유는 재제출하면 지워지지만, 이 이력에는 남는다 — 그게 이 표의 존재 이유.
 * 이력이 없으면(옛 문서·임시저장) 아무것도 그리지 않는다.
 */

import type { ExpenseDocDetail } from '../lib/expense-api';

const ACTION_STYLE: Record<string, string> = {
  제출: 'text-sky-700',
  승인: 'text-emerald-700',
  반려: 'text-rose-700',
  회수: 'text-amber-700',
  // 회의록 동의 서명 (v2.229.0)
  서명요청: 'text-sky-700',
  서명: 'text-emerald-700',
  서명취소: 'text-amber-700',
  내용수정: 'text-amber-700',
  서명완료: 'text-emerald-700',
  // 결재본 PDF 를 같은 자료로 다시 만듦 — 서식 변경 적용 (v2.238.0 · 결재 상태는 그대로)
  확정본재생성: 'text-slate-600',
  // 💸 경영지원의 송금 표시 (v2.267.0 · 결재 상태는 그대로)
  송금완료: 'text-emerald-700',
  송금일수정: 'text-amber-700',
  송금취소: 'text-amber-700',
};

/** 이력 이름을 사람 말로 — 붙여 쓴 저장 이름(서명요청)을 띄어 보여 준다 */
const ACTION_LABEL: Record<string, string> = {
  서명요청: '서명 요청',
  서명취소: '서명 거둠',
  내용수정: '내용 고침',
  서명완료: '서명 완료',
  확정본재생성: '결재본 다시 만듦',
  송금완료: '💸 송금완료',
  송금일수정: '송금일 고침',
  송금취소: '송금완료 취소',
};

export function DocHistoryList({ history }: { history: ExpenseDocDetail['history'] | undefined }) {
  if (!history || history.length === 0) return null;
  return (
    <section>
      <div className="text-xs font-semibold text-slate-700 mb-1.5">처리 이력</div>
      <ul className="text-xs space-y-1 border border-slate-200 rounded px-3 py-2 bg-slate-50/60">
        {history.map((h, i) => (
          <li key={i} className="flex gap-2 items-baseline">
            <span className="text-slate-400 shrink-0 tabular-nums">{h.at.slice(2, 16)}</span>
            <span className={`font-semibold shrink-0 ${ACTION_STYLE[h.action] ?? 'text-slate-700'}`}>
              {ACTION_LABEL[h.action] ?? h.action}
              {h.stage ? `(${h.stage})` : ''}
              {h.detail?.['재제출'] ? ' · 재제출' : ''}
            </span>
            <span className="text-slate-600 shrink-0">{h.actorName}</span>
            {h.reason && <span className="text-slate-500 break-all">— {h.reason}</span>}
          </li>
        ))}
      </ul>
    </section>
  );
}
